import { useSchedulesQuery } from '../api/selectSchedules';

const useFindSchedule = (templateId: string) => {
    const { data: templates } = useSchedulesQuery();
    console.log(templates, templateId);
    return templates?.find((t) => t.schedule_id === templateId);
};

export default useFindSchedule;
